import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuardFxn } from './core/guards/auth.guard';
import { profileResolver } from './core/resolver/profile.resolver';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthComponent,
    resolve: {
      profile: profileResolver
    },
    canActivate: [AuthGuardFxn],
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth-route').then((m) => m.routes)
      }
    ]
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardFxn],
    resolve: {
      profile: profileResolver
    },
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/after-login-page/pages-route').then((m) => m.routes)
      }
    ]
  }
];

RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled'
});